import {Button,Dialog,DialogActions,DialogContent,DialogTitle} from "@mui/material";
import React, { useState } from "react";
import Lang from "../../../components/Lang";
import Text from "../../../components/Text";
import mut from "../../../hooks/mut";

export default function RetireDialog({ lesson, setLessons,  open, setOpen }) {
    
    const go = async () => {
        let res = await mut("post", `/retire-class/${lesson.htClass}`,{tDate: lesson.tDate});
        if (res.success) {
            setLessons(prev => prev.filter(l => l.htClass !== lesson.htClass || (l.htClass===lesson.htClass && l.tDate<=lesson.tDate)))
            setOpen(false)
        }
  }

  const [check, setCheck] = useState("")
  
  let disabled = lesson.name===check ? true : false
   /*  lesson.name
    .normalize("NFC")
    .localeCompare(check.normalize("NFC"), "vi", { sensitivity: "base" }); */
  console.log(disabled)
  return (
    <Dialog open={open}>
      <DialogTitle>
        <Lang w="retireClass" />
      </DialogTitle>
      <DialogContent>
        <div>
          <Lang w="areYouSureYouWantToStopClass" /> {lesson.name}
        </div>
        <div>
          <Lang w="writeTheNameOfTheClassInTheBoxBelowToConfirm" />
        </div>
        <div>
          <Lang w="theLastLessonForThisClassIs" />{" "}
          {new Date(lesson.tDate).fDate()}
        </div>
        <br />
        <Text
          value={check}
          setValue={setCheck}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          onClick={() => setOpen(false)}
        >
          Close
        </Button>
        <Button
          color="success"
          disabled={!disabled}
          onClick={go}
        >
          Go
        </Button>
      </DialogActions>
    </Dialog>
  );
}